import pageSeo from '@/middleware/async-middlewares/page-seo'
import { compareRoutes } from '@/plugins/helper'

export default async function(ctx) {
  const { from, route } = ctx

  if (from && route) {
    const { isOnlyHashChanged } = compareRoutes(from, route)

    if (isOnlyHashChanged) return
  }

  await Promise.all([pageSeo(ctx)])
}
